export const Details = {
  CreatedBy: "createdBy" as const,
  ReceiptCategoryId: "receiptCategoryId" as const,
  ReceiptCategory: "receiptCategory" as const,
  ReceiptCategoryType: "receiptCategoryType" as const,
  Intent: "intent" as const,
  OtherExplanation: "otherExplanation" as const,
  Persons: "persons" as const,
  Amount: "amount" as const,
  Currency: "currency" as const,
  PurchaseDate: "purchaseDate" as const,
  CreatedDate: "createdDate" as const,
  PaymentMethodId: "paymentMethodId" as const,
  PaymentMethod: "paymentMethod" as const,
  PaymentMethodType: "paymentMethodType" as const,
  PaymentStatus: "paymentStatus" as const,
  RecipientAccount: "recipientAccount" as const,
  PaymentDate: "paymentDate" as const,
  Dimensions: "dimensions" as const,
  ShowDimensions: "showDimensions" as const,
  FilesToUpload: "filesToUpload" as const,
  CanPayEmployee: "canPayEmployee" as const,
  PersonNumber: "personNumber" as const,
  BankAccount: "bankAccount" as const,
  ClearingNumber: "clearingNumber" as const,
  InternalNote: "internalNote" as const,
  IsManualPayment: "isManualPayment" as const,
  SupplierName: "supplierName" as const,
  IsOtherPaymentMethod: "isOtherPaymentMethod" as const,
  OtherPaymentMethodExplanation: "otherPaymentMethodExplanation" as const,
}

export const Todo = {
  Dimensions: "dimensions" as const,
  ShowDimensions: "showDimensions" as const,
  CanPayEmployee: "canPayEmployee" as const,
  PersonNumber: "personNumber" as const,
  BankAccount: "bankAccount" as const,
  ClearingNumber: "clearingNumber" as const,
  IsManualPayment: "isManualPayment" as const,
  ReceiptCategoryId: "receiptCategoryId" as const,
  ReceiptCategory: "receiptCategory" as const,
  ReceiptCategoryType: "receiptCategoryType" as const,
  Intent: "intent" as const,
  OtherExplanation: "otherExplanation" as const,
  Persons: "persons" as const,
  PurchaseDate: "purchaseDate" as const,
  Amount: "amount" as const,
  Currency: "currency" as const,
  PaymentMethodId: "paymentMethodId" as const,
  PaymentMethod: "paymentMethod" as const,
  PaymentMethodType: "paymentMethodType" as const,
  FilesToUpload: "filesToUpload" as const,
  IsOtherPaymentMethod: "isOtherPaymentMethod" as const,
  OtherPaymentMethodExplanation: "otherPaymentMethodExplanation" as const,
}

export const TodoExtended = {
  FilesToUpload: "filesToUpload" as const,
}

export const SendBack = {
  Message: "message" as const,
}

export const Filter = {
  SerialNumber: "serialNumber" as const,
  ViewStatuses: "viewStatuses" as const,
  ReceiptCategories: "receiptCategories" as const,
  Created: "created" as const,
  Amount: "amount" as const,
  UploadedByUsers: "uploadedByUsers" as const,
  PaymentState: "paymentState" as const,
  PaymentMethod: "paymentMethod" as const,
  PaymentMethodName: "paymentMethodName" as const,
  Dimensions: "dimensions" as const,
  PaymentMethodTypes: "paymentMethodTypes" as const,
}

export const AddPaymentMethod = {
  Id: "id" as const,
  Type: "type" as const,
  PaymentMethodType: "paymentMethodType" as const,
  Name: "name" as const,
  CurrencyMarkup: "currencyMarkup" as const,
  IsActive: "isActive" as const,
  Amount: "amount" as const,
  CanDeactivate: "canDeactivate" as const,
  EditMode: "editMode" as const,
}

export const ReceiptPerson = {
  Id: "id" as const,
  Name: "name" as const,
  Company: "company" as const,
}

export const ReceiptDraftTodo = {
  FilesToUpload: "filesToUpload" as const,
  ReceiptCategory: "receiptCategory" as const,
  ReceiptCategoryId: "receiptCategoryId" as const,
  Amount: "amount" as const,
  Currency: "currency" as const,
  PaymentMethodId: "paymentMethodId" as const,
  PaymentMethod: "paymentMethod" as const,
  Dimensions: "dimensions" as const,
  ShowDimensions: "showDimensions" as const,
  DocumentDraft: "documentDraft" as const,
  DocumentDraftId: "documentDraftId" as const,
  ReceiptPersons: "receiptPersons" as const,
  ReceiptPurpose: "receiptPurpose" as const,
  OtherExplanation: "otherExplanation" as const,
  ReceiptCategoryType: "receiptCategoryType" as const,
}

export const ReceiptUploadedFile = {
  IsDocumentDraft: "isDocumentDraft" as const,
}

export const AutomationRuleCreate = {
  ReceiptDraft: "receiptDraft" as const,
}

